import * as React from 'react';
import { Button } from '../../../components/Bootstrap';
import { TabPanel } from '../../../components';
import { History } from 'history';
import { MenuSection } from './MenuSection';
import { Menu_menu_categories as Category, Menu_menu_categories_items as MenuItem } from './__generated__/Menu';

interface MenuListProps {
  categories: Category[];
  venueId: string;
  menuId: string;
  categoryId: string;
  loading: boolean;
  name: string;
  history: History;

  addCategories();

  onOrderChange(drinks: string[]);
  onToggleEnabled(item: MenuItem);
  onToggleFeatured(item: MenuItem);
  onDeleteItem(item: MenuItem);
  copyMenuItem(item: MenuItem);

  onClickAdd();
}

const EMPTY_CONTENT = `Looks like your menu doesn't have any categories setup. Categories help organize your items and show up as a different row for your customers on the app or website.`;

export class MenuList extends React.Component<MenuListProps, {}> {
  renderContent = (category: Category) => {
    return (
      <MenuSection
        onOrderChange={this.props.onOrderChange}
        onSelectItem={this.goToItem}
        onToggleEnabled={this.props.onToggleEnabled}
        onDeleteItem={this.props.onDeleteItem}
        onClickNewItem={this.props.onClickAdd}
        onToggleFeatured={this.props.onToggleFeatured}
        copyMenuItem={this.props.copyMenuItem}
        category={category}
      />
    );
  };

  renderTitle = (section) => {
    return section.name;
  };

  toggle = (index) => {
    const section = this.props.categories[index];
    this.goToCategory(section.id);
  };

  goToCategory = (categoryId) => {
    const { menuId, venueId } = this.props;
    this.props.history.push(`/venue/${venueId}/menu/list/${menuId}/category/${categoryId}`);
  };

  goToItem = (menuItem: MenuItem) => {
    const category = this.props.categories.find((category) => {
      if (!category.id || Number(category.id) < 0) {
        return false;
      }

      return !!category.items.find((m) => {
        return m.item.id === menuItem.item.id;
      });
    });

    const { menuId, venueId } = this.props;
    if (category) {
      this.props.history.push(`/venue/${venueId}/menu/${menuId}/category/${category.id}/item/${menuItem.item.id}`);
    }
  };

  render() {
    if (this.props.loading) {
      return <div>Loading...</div>;
    }

    if (this.props.categories.length === 0) {
      return (
        <div className='d-flex flex-column w-100 h-100 align-items-center justify-content-center fulfillment-centers-empty'>
          <p className='mt-4 mb-4 text-center'>{EMPTY_CONTENT}</p>
          <Button type='button' color='primary' className='btn--rounded ps-4 pe-4' onClick={this.props.addCategories}>
            Add categories
          </Button>
        </div>
      );
    }

    const activeTabIndex = this.props.categories.map((category) => category.id).indexOf(this.props.categoryId);

    return (
      <div className='menu-editor'>
        <h3 className='menu-editor-name'>{this.props.name}</h3>
        <TabPanel
          sections={this.props.categories}
          activeTab={activeTabIndex}
          renderContent={this.renderContent}
          renderTitle={this.renderTitle}
          toggle={this.toggle}
          fillContainer={false}
        />
      </div>
    );
  }
}
